export let dataProps = {
    sale_id: 0,
    tailoring_item: { id: 0, detail: null },
    fabric: { id: 0, detail: null },
	customer: { id: 0, detail: null },
    store_id: null,
    sales_man_id: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/garmentCustomiser/properties.js